import { styled, Typography, type TypographyProps } from "~/common/mui";

export type SearchInputGroupTextProps = TypographyProps;

const StyledTypography = styled(Typography)({
  whiteSpace: "nowrap",
});

export const SearchInputGroupText = (props: SearchInputGroupTextProps) => {
  return <StyledTypography variant="bodyLarge" {...props} />;
};
